/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { injectable } from 'inversify';

import { BreadcrumbItemAgent, getAgent } from './agent';

const is = require('is_js');

@injectable()
export class BreadcrumbService {
  private static instance: BreadcrumbService;
  public agent: BreadcrumbItemAgent;
  static displayName = 'BreadcrumbService';
  constructor(props: any = {}) {
    this.agent = getAgent();
  }

  public static getInstance(props: any = {}): BreadcrumbService {
    if (!BreadcrumbService.instance) {
      BreadcrumbService.instance = new BreadcrumbService(props);
    }
    return BreadcrumbService.instance;
  }

  public getBreadCrumbItems() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getBreadcrumbItemsSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }
}
